module.exports = __webpack_public_path__ + "media/features/time-based-analysis-2c6f25a4.jpg";